<script setup>
import requests from "@/OfOnboardingRequests";
import { merchants } from "@/store";
import OfButton from "@dk.onlinefundraising/vue-utils/src/utils/OfButton.vue";
import OfModalBlock from "@dk.onlinefundraising/vue-utils/src/utils/OfModalBlock.vue";
import OfSpinner from "@dk.onlinefundraising/vue-utils/src/utils/OfSpinner.vue";
import OfSubModal from "@dk.onlinefundraising/vue-utils/src/utils/OfSubModal.vue";
import { onMounted, ref, defineEmits } from "vue";

const selectedCampaign = ref('');
const campaigns = ref();
const pendingExport = ref(false);

const emit = defineEmits(['close']);

function getAllAvailableCampaigns() {
    requests.getAllAvailableCampaigns().then(results => {
        campaigns.value = results;
    })
}
function getMerchantNameById(id) {
    const merchant = merchants.value.find((merchant) => merchant.merchantId == id);

    return merchant ? merchant.name : '';
}
function startExport() {
    requests.startExport(selectedCampaign.value.campaignGuid).then((exportGuid) => {
        if (exportGuid) {
            getExport(exportGuid);
            pendingExport.value = true;
        }
    })
}
function getExport(exportGuid) {
    setTimeout(() => {

        requests.getExport(exportGuid).then((result) => {
            if (result?.state == 'PROCESSED') {
                pendingExport.value = false;
                downloadExport(result.exportGuid)
            } else {
                getExport(exportGuid);
            }
        })

    }, 3000)
}
function downloadExport(exportGuid) {
    requests.downloadExport(exportGuid).then((response) => {
        const link = document.createElement('a');


        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const file = new File([blob], 'data.xlsx', { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        link.href = window.URL.createObjectURL(file);


        link.download = (selectedCampaign.value.name ?? 'download') + '.xlsx'; // File name


        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
    })
}
onMounted(() => {
    getAllAvailableCampaigns();
})
</script>
<template>
    <OfSubModal passive @close="emit('close')" class="export-modal" width="550px">

        <template #heading>Export</template>

        <template #content>
            <OfModalBlock>

                <template #block-header>

                    <h4>Export</h4>

                    <small class="input-helper-text">
                        Select a campaign to export the current results. It will be downloaded automatically once ready,
                        so please keep the browser open until it's finished.
                    </small>

                </template>

                <template #block-content>

                    <div class="checkform">

                        <div class="checkform-campaign">
                            <select v-model="selectedCampaign" type="text">

                                <option disabled value=""> Choose campaign to export </option>

                                <optgroup v-for="(merchant, index) in campaigns" :key="index"
                                    :label="getMerchantNameById(index)">
                                    <option v-for="campaign in merchant" :key="campaign.campaignGuid" :value="campaign">
                                        {{ campaign.name }}
                                    </option>
                                </optgroup>

                            </select>
                        </div>

                        <div class="checkform-submit">

                            <OfButton size="large" text="Export" coloring="primary" @click="startExport" />

                        </div>

                        <div v-if="pendingExport" style="position: relative">
                            <OfSpinner />
                        </div>

                    </div>

                </template>
            </OfModalBlock>
        </template>

    </OfSubModal>
</template>
<style scoped>
.checkform {
    margin-bottom: 1rem;
}

.checkform-campaign {
    flex: 1 1 80%;
    position: relative;
    margin-bottom: 1rem;
}

.checkform-campaign>input {
    height: 56px;
    border-radius: 0;
}

.checkform-submit {
    flex: 1 1 auto;
    font-weight: 500;
    font-family: Roboto, sans-serif;
}
</style>